import React, { Component } from 'react';
import PropTypes from 'prop-types'; // to validate and set default props  coming to this component
import Banner from 'components/Banner';
import { connect } from 'react-redux'; // to connect to redux store from containers redux.js or any other redux store
import Session from 'components/Session';
import NavOnScroll from 'components/NavOnScroll';
import MyrbDescription from 'components/MyrbDescription/MyrbDescription';
import Benefits from 'components/Benefits';
import Community from 'components/Community';
import Reviews from 'components/Reviews';
import Footer from 'components/MiniFooter';
import cn from 'classnames'; // to use global class name eg. classes from grid.css in public folder
import FullScreenVideo from 'components/FullScreenVideo';
import { bannerSelector } from 'components/Banner/Banner.redux';
import { Helmet } from 'react-helmet';
import s from './Home.scss';// to import local scss fle


class Home extends Component {
  static propTypes = {
    video: PropTypes.bool,

  };
  static defaultProps = {
    video: false,
    logoutUser: () => {},
  };

  constructor(props) {
    super(props);
    this.state = {
      showFixedNavbar: false,
    };
    this.handleScroll = this.handleScroll.bind(this);
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }
  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll(event) {
    const scrollTop = event.srcElement.body.scrollTop;
    if (scrollTop > 80) {
      this.setState({ showFixedNavbar: true });
    } else {
      this.setState({ showFixedNavbar: false });
    }
  }
  render() {
    const bannerData = {
      bannerHeader: 'GET DISCOVERED NATIONALLY',
      bannerDesc: "The world's leader in innovative football recruiting using academics, biometrics, & athletic analysis.",
      backgroundUrl: 'https://media.dev.myrecruitboard.com/Images/bgDesktop.png',
      fullsize: true,
    };
    return (
      <div className={cn('row', s.homePageContainer)}>
        <Helmet>
          <title>MyRecruitBoard – Get Recruited. College Football | MyRecruitBoard.com</title>
          <meta name="description" content="Leader in College Football recruiting. Contact with Coaches Right away." />
          <meta
            name="Keywords" content="College Football recruiting, Contact Football Coaches, College Sports, College Football Scholarships, Quarterback,
            Offensive Tackle, Offensive guard, Quarterback, Running back, Wide receiver, Tight end, Defensive tackle, Defensive end, Kicker "
          />
        </Helmet>
        {this.props.video === true ? <FullScreenVideo /> :
        <div className={cn('row', s.homePageContainer)}>
          {this.state.showFixedNavbar === true ? <NavOnScroll {...this.props} /> : ''}
          <Banner {...this.props} data={bannerData} />
          <MyrbDescription />
          <Benefits />
          <Community />
          <Reviews />
          <Footer />
        </div>
                }
      </div>
    );
  }
}


export default connect(bannerSelector, {})(Session(Home));



// WEBPACK FOOTER //
// ./src/containers/Home/Home.js